import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ko from "./locales/ko.json";
import zh from "./locales/zh.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import ja from "./locales/ja.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";

const SUPPORTED = ["en", "ko", "zh", "ja", "es", "fr", "pt", "de"];

function detectLang() {
  const saved = localStorage.getItem("lang");
  if (saved) return saved;

  // e.g. "ko-KR" → "ko", "zh-TW" → "zh"
  const browserLangs = navigator.languages || [navigator.language];
  for (const raw of browserLangs) {
    const code = raw.split("-")[0].toLowerCase();
    if (SUPPORTED.includes(code)) return code;
  }
  return "en";
}

const savedLang = detectLang();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ko: { translation: ko },
    zh: { translation: zh },
    es: { translation: es },
    fr: { translation: fr },
    ja: { translation: ja },
    pt: { translation: pt },
    de: { translation: de },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ko", label: "한국어" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "pt", label: "Português" },
  { code: "de", label: "Deutsch" },
];

export const changeLanguage = (code) => {
  localStorage.setItem("lang", code);
  window.location.reload();
};

export default i18n;
